export const addCommas = (num) =>
    num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const removeNonNumeric = (num) => {
    if (num === null || num === undefined) return "";
    let str = num.toString();
    if (str.includes(".")) {
        str = str.split(".")[0];
    }
    str = str.replace(/[^0-9]/g, "");
    if (str === "") return "";
    return parseInt(str, 10).toString();
};

